import { render, staticRenderFns } from "./poweredby.vue?vue&type=template&id=10c5854a"
import script from "./poweredby.vue?vue&type=script&lang=js"
export * from "./poweredby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports